import styled from "@emotion/styled"
import { px } from "@mantine/core"
import { theme } from "@tfg/themes"

import { SUPPLIER_CARD_HEIGHT } from "~/pages/Brand/Products/Details/constants.ts"

export const HorizontalDivider = styled.div({
  width: 20,
  height: 40,
  borderBottom: "1px solid black",
})

type VerticalDividerProps = {
  itemCount: number
}
export const VerticalDivider = styled.div<VerticalDividerProps>(
  ({ itemCount }) => ({
    width: 20,
    borderLeft: "1px solid black",
    position: "absolute",
    height:
      (SUPPLIER_CARD_HEIGHT + Number(px(theme.spacing.md))) * (itemCount - 1),
    marginTop: 40,
  })
)
